import generalAssemblyFormFileAr from "@assets/files/investors/Proxy_AR.pdf";
import generalAssemblyFormFileEn from "@assets/files/investors/Proxy_Eng.pdf";
import generalAssemblyForm from "@assets/images/investors/financial-report.png";
import { GeneralAssemblyForm } from "../types";

export const generalAssemblyInvitations = [
  {
    id: 1,
    title: "generalAssemblyInvitation",
    url: (locale: string) =>
      `https://www.saudiexchange.sa/wps/portal/saudiexchange/newsandreports/issuer-news/issuer-announcements/issuer-announcements-details/?anId=95262&anCat=1&cs=2240&locale=${locale}`,
  },
];

export const generalAssemblyForms: GeneralAssemblyForm[] = [
  {
    id: 1,
    title: "proxyForm",
    year: 2026,
    image: {
      name: "general-assembly-form",
      url: generalAssemblyForm,
    },
    file: {
      en: generalAssemblyFormFileEn,
      ar: generalAssemblyFormFileAr,
    },
  },
];
